export default () => {
    const textarea = document.querySelector('#contact_body');

    if (!textarea) {
        return
    }

    textarea.addEventListener('input', autoResize, false);

    function autoResize() {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
    }
}